import mixpanel from 'mixpanel-browser';
import { FC, useEffect, useState } from 'react';
import { useResponseHistoryContext } from '../../../../../contexts/ResponseHistoryContext';
import { BasicButton } from '../../../../shared/buttons/BasicButton';

import styles from './LikedResponsesHistory.module.css';
import { ResponseCard } from './ResponseCard';
import axios from 'axios';
import { LikedResponse } from '../../../../../types/FormTypes';

export const RecentHistory: FC = () => {
  const {
    loading,
    contentResponses,
    contentResponsesError,
    canLoadMoreContentResponses,
    loadMoreContentResponses,
  } = useResponseHistoryContext();

  if (contentResponsesError) {
    return (
      <div className={styles['container']}>
        <p className={styles['no-responses-text']}>⚠️Something went wrong...</p>
      </div>
    );
  }

  if (!contentResponses) {
    return (
      <div className={styles['container']}>
        <p className={styles['no-responses-text']}>Loading...</p>
      </div>
    );
  }

  if (contentResponses.length === 0) {
    return (
      <div className={styles['container']}>
        <p className={styles['no-responses-text']}>
          You have no like history for this session.
        </p>
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      {contentResponses.map((contentResponseData) => {
        return (
          <ResponseCard key={contentResponseData.id} {...contentResponseData} />
        );
      })}
      {canLoadMoreContentResponses && (
        <div className={styles['load-more-button']}>
          <BasicButton
            type="button"
            text={loading ? 'Loading' : 'Load More'}
            loading={loading}
            disabled={
              loading || !contentResponses || contentResponses.length === 0
            }
            onClick={() => {
              loadMoreContentResponses();
            }}
          />
        </div>
      )}
    </div>
  );
};
